module.exports = __webpack_public_path__ + "img/375.2bd32021.jpg";